<template>
<!-- <ion-content> -->
    <div slot="fixed">
        <CCard>
            <CCardHeader class="grey-header d-flex mob-flex-column ai-center">
                <CRow class="flex-flow-column">
                    <CCol>
                        <strong>{{$t('assignPricing.title')}}</strong>
                    </CCol>
                    <p class="desc">{{ $t("assignPricing.desc") }}</p>
                </CRow>
                <button @click="navigateToAddNewPricing()" type="button"
                        class="btn ml-auto btn-lit-blue mob-w100 btn-success btn-sm">{{$t('assignPricing.addNew')}}
                </button>
            </CCardHeader>


            <!--      <CCardHeader>-->
            <!--        <CCol>-->
            <!--          <strong>{{$t('assignPricing.title')}}</strong>-->
            <!--        </CCol>-->
            <!--      </CCardHeader>-->

            <!-- <div v-if="assignedTierList.length>0">
              <pre class="language-json"><code>{{assignedTierList}}</code></pre>
            </div>-->
               
            <CCardBody>
                
                <!--                <CRow class="m-w-500px">-->
                <!--                    <CCol xs="8" lg="8">-->
                <!--                        <div v-if="assignedTiers.length>0">-->
                <!--                            <CRow>-->
                <!--                                &lt;!&ndash; <CCol>-->
                <!--                                  <strong>{{$t('assignPricing.slctAgnt')}}</strong>-->
                <!--                                </CCol> &ndash;&gt;-->
                <!--                                <CCol>-->
                <!--                                    <label for=""> <strong>{{$t('assignPricing.slctAgnt')}}</strong></label>-->
                <!--                                    <div v-if="assignedTiers.length>0">-->
                <!--                                        <multiselect-->
                <!--                                                v-model="selectedTier"-->
                <!--                                                :label="assignedTiers.agentName"-->
                <!--                                                :options="assignedTiers"-->
                <!--                                                :track-by="assignedTiers.b2bId"-->
                <!--                                                :disabled="false"-->
                <!--                                                @input="onChange"-->
                <!--                                                :isMultiple="false"-->
                <!--                                                :searchable="true"-->
                <!--                                        >-->
                <!--                                            <template slot="singleLabel" slot-scope="props">{{ props.option.agentName-->
                <!--                                                }}-->
                <!--                                            </template>-->
                <!--                                            <template slot="option" slot-scope="props">-->
                <!--                                                <div>-->
                <!--                                                    <span>{{ props.option.agentName }}</span>-->
                <!--                                                    &lt;!&ndash; <strong class="right" >{{ props.option.b2bId }}</strong> &ndash;&gt;-->
                <!--                                                </div>-->
                <!--                                            </template>-->
                <!--                                        </multiselect>-->
                <!--                                    </div>-->
                <!--                                </CCol>-->
                <!--                            </CRow>-->
                <!--                        </div>-->
                <!--                    </CCol>-->
                <!--                    <CCol xs="4" lg="4" class="d-flex ai-flex-end">-->
                <!--&lt;!&ndash;                        <div v-if="assignedTierList.length>0" class="w-100">&ndash;&gt;-->

                <!--                            &lt;!&ndash;              <CButton class="w-100"&ndash;&gt;-->
                <!--                            &lt;!&ndash;                color="primary"&ndash;&gt;-->
                <!--                            &lt;!&ndash;                @click="navigateToAddNewPricing()"&ndash;&gt;-->
                <!--                            &lt;!&ndash;              >{{$t('assignPricing.addNew')}}</CButton>&ndash;&gt;-->
                <!--&lt;!&ndash;                        </div>&ndash;&gt;-->
                <!--                    </CCol>-->
                <!--                </CRow>-->

                <div class="m-auto max-width-1000px">
                    <div v-if="assignedTiers && assignedTiers.length>0"
                         class="card assign pricing-card sticky-title-bar   ">
                        <div class="d-flex">
                            <label for="" class="title"> <strong>{{$t('assignPricing.slctAgnt')}}</strong></label>
                            <div class="multiselect-assignprice">


                                <!-- <cAgent  agentType=null v-model="agent"  @input="onChange" :isMultiple="false" rules="required" /> -->
                                <multiselect
                                        v-model="selectedTier"
                                        :searchable='true'
                                        :custom-label="agencyNameWithCode"
                                        :showLabels="false"
                                        :options="assignedTiers"
                                        :track-by="'b2bId'"
                                        :disabled="false"
                                        :allow-empty="false"
                                        @input="onChange"
                                        :isMultiple="false"

                                >
                                    <template slot="singleLabel" slot-scope="props">
                                        <div class="d-flex cagent-selected"><span class="">{{ props.option['agentName'] }}</span>
                                            <div v-if="props.option['agencyCode']" class="right">({{
                                                props.option['agencyCode'] }})
                                            </div>
                                        </div>

                                    </template>

                                    <template slot="option" slot-scope="props">
                                        <div class="d-flex"><strong class="w-50 txt-over-ellips">{{
                                            props.option['agentName'] }}</strong>
                                            <span class="text-right ml-auto w-50 txt-over-ellips">{{ props.option['agencyCode'] }}</span>
                                        </div>
                                    </template>
                                    <template #noResult>
                                        <strong>
                                            {{$t('manageAgent.resultEmpty')}}
                                        </strong>
                                    </template>
                                    <template #noOptions>
                                        <strong>
                                            {{$t('manageAgent.optionEmpty')}}
                                        </strong>
                                    </template>
                                </multiselect>
                            </div>
                        </div>
                    </div>

                    <!-- <div v-else>
                        <label>
                            {{$t('assignPricing.noTiers')}}
                        </label>
                    </div> -->
                    <div class="page-controllers">
                        <div class="page-controller-wrap">
                            <div class="d-flex align-item-center per-item">
                                <span class="align-item-center d-flex">{{$t('manageAgent.itemsPerPage')}}</span>
                                <select class="form-control" v-model="assignPricingWatchList.itemsPerPage">
                                    <option v-for="itemsPerPage in assignPricingWatchList.lsItemsPerPage" :key="itemsPerPage"
                                            :value="itemsPerPage">{{itemsPerPage}}
                                    </option>

                                </select>
                            </div>
                            <div class="ml-auto">
                                <cPaginationLenOption :paginationWatchLs="assignPricingWatchList"/>
                            </div>
                        </div>


                        <div class="d-flex align-item-center page-n">

                            <CPagination
                                    :activePage.sync="assignPricingWatchList.currentPageNum"
                                    :pages="getTotalPages()"
                                    align="center"
                            />
                        </div>
                    </div>




                    <div v-if='assignedTierList&& assignedTierList.length'>
                        <div v-for="(assignedTier,index) in assignedTierList" :key="index+'p'">
                            <div class="card assign pricing-card" v-if="getAgentCountForAssTiersView(index)">
                                <div class=" card-head d-flex ai-center">
                                    <div class="align-left a-name">
                                        <h3>
                                            {{assignedTier.agentName}}

                                        </h3>
                                        <span>{{assignedTier.agencyCode}}</span>
                                    </div>
                                    <div class="align-right">
                                        <button @click="navigateToAddNewPricing(assignedTier)" data-v-c2da5fea=""
                                                type="button" color="info"
                                                class="btn btn-lit-blue mob-w100 btn-success btn-sm">
                                            {{$t('assignPricing.edit')}}
                                        </button>
                                    </div>
                                </div>
                                <div v-if='assignedTier && assignedTier.pricing && assignedTier.pricing.length'>


                                    <div v-for="(pricing,index) in assignedTier.pricing" :key="index+'oc'"
                                         class="card-body pb-0px">
                                        <div class="wrap d-flex">
                                            <div class="align-left d-flex ai-center">
                                                <img
                                                        src="@imgPath/img/svg/icons/mark-tick.svg"
                                                        alt=""
                                                />

                                                <span>{{pricing.tier.name}}</span>
                                            </div>
                                            <div class="right-align">
                                                <span>{{$t('assignPricing.bkFrom')}} <span>{{pricing.fromDate|formatDate}}</span> {{$t('assignPricing.to')}}  <span>{{pricing.toDate|formatDate}}</span></span>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="wrap d-flex">
                                        <div class="align-left d-flex ai-center">
                                            <img
                                                    src="@imgPath/img/svg/icons/mark-tick.svg"
                                                    alt=""
                                            />

                                            <span>New Year Discount 2021</span>
                                        </div>
                                        <div class="right-align">
                                            <span>Booking from <span>21 Mar 2020</span> to <span>21 Mar 2020</span></span>
                                        </div>
                                    </div>
                                    <div class="wrap d-flex">
                                        <div class="align-left d-flex ai-center">
                                            <img
                                                    src="@imgPath/img/svg/icons/mark-tick.svg"
                                                    alt=""
                                            />

                                            <span>New Year Discount 2021</span>
                                        </div>
                                        <div class="right-align">
                                            <span>Booking from <span>21 Mar 2020</span> to <span>21 Mar 2020</span></span>
                                        </div>
                                    </div>
                                    <div class="wrap d-flex">
                                        <div class="align-left d-flex ai-center">
                                            <img
                                                    src="@imgPath/img/svg/icons/mark-tick.svg"
                                                    alt=""
                                            />

                                            <span>New Year Discount 2021</span>
                                        </div>
                                        <div class="right-align">
                                            <span>Booking from <span>21 Mar 2020</span> to <span>21 Mar 2020</span></span>
                                        </div>
                                    </div>

                                </div>
                                </div>
                            </div>
                        </div>
                            <div class="card assign pricing-card">
                                <div class=" card-head d-flex ai-center">
                                    <div class="align-left a-name">
                                        <h3>
                                            Jenis Raj
                                        </h3>
                                        <span>
                                  MMK 0101 1244
                        </span>
                                    </div>
                                    <div class="align-right">
                                        <button data-v-c2da5fea="" type="button" color="info" class="btn btn-lit-blue mob-w100 btn-success btn-sm">Edit </button>
                                    </div>
                                </div>
                                <div class="card-body pb-0px">
                                    <div class="wrap d-flex">
                                        <div class="align-left d-flex ai-center">
                                            <img
                                                    src="@imgPath/img/svg/icons/mark-tick.svg"
                                                    alt=""
                                            />

                                            <span>New Year Discount 2021</span>
                                        </div>
                                        <div class="right-align">
                                            <span>Booking from <span>21 Mar 2020</span> to <span>21 Mar 2020</span></span>
                                        </div>
                                    </div>
                                    <div class="wrap d-flex">
                                        <div class="align-left d-flex ai-center">
                                            <img
                                                    src="@imgPath/img/svg/icons/mark-tick.svg"
                                                    alt=""
                                            />

                                            <span>New Year Discount 2021</span>
                                        </div>
                                        <div class="right-align">
                                            <span>Booking from <span>21 Mar 2020</span> to <span>21 Mar 2020</span></span>
                                        </div>
                                    </div>
                                    <div class="wrap d-flex">
                                        <div class="align-left d-flex ai-center">
                                            <img
                                                    src="@imgPath/img/svg/icons/mark-tick.svg"
                                                    alt=""
                                            />

                                            <span>New Year Discount 2021</span>
                                        </div>
                                        <div class="right-align">
                                            <span>Booking from <span>21 Mar 2020</span> to <span>21 Mar 2020</span></span>
                                        </div>
                                    </div>
                                    <div class="wrap d-flex">
                                        <div class="align-left d-flex ai-center">
                                            <img
                                                    src="@imgPath/img/svg/icons/mark-tick.svg"
                                                    alt=""
                                            />

                                            <span>New Year Discount 2021</span>
                                        </div>
                                        <div class="right-align">
                                            <span>Booking from <span>21 Mar 2020</span> to <span>21 Mar 2020</span></span>
                                        </div>
                                    </div>

                                </div>
                            </div>





                            <div class="card assign pricing-card">
                                <div class=" card-head d-flex ai-center">
                                    <div class="align-left a-name">
                                        <h3>
                                            Jenis Raj
                                        </h3>
                                        <span>
        MMK 0101 1244
                        </span>
                                    </div>
                                    <div class="align-right">
                                        <button data-v-c2da5fea="" type="button" color="info" class="btn btn-lit-blue mob-w100 btn-success btn-sm">Edit </button>
                                    </div>
                                </div>
                                <div class="card-body pb-0px">
                                    <div class="wrap d-flex">
                                        <div class="align-left d-flex ai-center">
                                            <img
                                                    src="@imgPath/img/svg/icons/mark-tick.svg"
                                                    alt=""
                                            />

                                            <span>New Year Discount 2021</span>
                                        </div>
                                        <div class="right-align">
                                            <span>Booking from <span>21 Mar 2020</span> to <span>21 Mar 2020</span></span>
                                        </div>
                                    </div>
                                    <div class="wrap d-flex">
                                        <div class="align-left d-flex ai-center">
                                            <img
                                                    src="@imgPath/img/svg/icons/mark-tick.svg"
                                                    alt=""
                                            />

                                            <span>New Year Discount 2021</span>
                                        </div>
                                        <div class="right-align">
                                            <span>Booking from <span>21 Mar 2020</span> to <span>21 Mar 2020</span></span>
                                        </div>
                                    </div>
                                    <div class="wrap d-flex">
                                        <div class="align-left d-flex ai-center">
                                            <img
                                                    src="@imgPath/img/svg/icons/mark-tick.svg"
                                                    alt=""
                                            />

                                            <span>New Year Discount 2021</span>
                                        </div>
                                        <div class="right-align">
                                            <span>Booking from <span>21 Mar 2020</span> to <span>21 Mar 2020</span></span>
                                        </div>
                                    </div>
                                    <div class="wrap d-flex">
                                        <div class="align-left d-flex ai-center">
                                            <img
                                                    src="@imgPath/img/svg/icons/mark-tick.svg"
                                                    alt=""
                                            />

                                            <span>New Year Discount 2021</span>
                                        </div>
                                        <div class="right-align">
                                            <span>Booking from <span>21 Mar 2020</span> to <span>21 Mar 2020</span></span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="card assign pricing-card">
                                <div class=" card-head d-flex ai-center">
                                    <div class="align-left a-name">
                                        <h3>
                                            Jenis Raj
                                        </h3>
                                        <span>
        MMK 0101 1244
                        </span>
                                    </div>
                                    <div class="align-right">
                                        <button data-v-c2da5fea="" type="button" color="info" class="btn btn-lit-blue mob-w100 btn-success btn-sm">Edit </button>
                                    </div>
                                </div>
                                <div class="card-body pb-0px">
                                    <div class="wrap d-flex">
                                        <div class="align-left d-flex ai-center">
                                            <img
                                                    src="@imgPath/img/svg/icons/mark-tick.svg"
                                                    alt=""
                                            />

                                            <span>New Year Discount 2021</span>
                                        </div>
                                        <div class="right-align">
                                            <span>Booking from <span>21 Mar 2020</span> to <span>21 Mar 2020</span></span>
                                        </div>
                                    </div>
                                    <div class="wrap d-flex">
                                        <div class="align-left d-flex ai-center">
                                            <img
                                                    src="@imgPath/img/svg/icons/mark-tick.svg"
                                                    alt=""
                                            />

                                            <span>New Year Discount 2021</span>
                                        </div>
                                        <div class="right-align">
                                            <span>Booking from <span>21 Mar 2020</span> to <span>21 Mar 2020</span></span>
                                        </div>
                                    </div>
                                    <div class="wrap d-flex">
                                        <div class="align-left d-flex ai-center">
                                            <img
                                                    src="@imgPath/img/svg/icons/mark-tick.svg"
                                                    alt=""
                                            />

                                            <span>New Year Discount 2021</span>
                                        </div>
                                        <div class="right-align">
                                            <span>Booking from <span>21 Mar 2020</span> to <span>21 Mar 2020</span></span>
                                        </div>
                                    </div>
                                    <div class="wrap d-flex">
                                        <div class="align-left d-flex ai-center">
                                            <img
                                                    src="@imgPath/img/svg/icons/mark-tick.svg"
                                                    alt=""
                                            />

                                            <span>New Year Discount 2021</span>
                                        </div>
                                        <div class="right-align">
                                            <span>Booking from <span>21 Mar 2020</span> to <span>21 Mar 2020</span></span>
                                        </div> -->
                                </div>
                            </div>
                        </div>
                         <!-- <ion-infinite-scroll  @ionInfinite="loadData($event)"> 
                <ion-infinite-scroll-content
                        loading-spinner="bubbles"
                        loading-text="Loading more data...">
                </ion-infinite-scroll-content>
            </ion-infinite-scroll> -->
                    </div>
                   
                    <div v-else>
                        <label v-if="isResponseFetched">
                            {{$t('assignPricing.noTiers')}}
                        </label>
                    </div>

                </div>
                <!-- <CDataTable
                        :fields="tierField"
                        :items="assignedTierList!=null?assignedTierList:[]"
                        :loading="assignedTierList.length>0?false:true"
                        class="usersTable border-grey assign-price-table table-striped table-hover"
                        id="#user-manage-table"
                >


                    <template #agentName='{item,index}'>
                        <td>
                            <div> {{item.agentName}}</div>
                        </td>
                    </template>
                    <template #pricing="{item}">
                        <td class="py-2">
                            <div v-for="(tier,index) in item.pricing" :key="index" class="assign-price">
                                <strong>{{tier.tier.name}}</strong>
                                <small>{{$t('assignPricing.pricingDetails',{fromDate:formatDate(tier.fromDate),toDate:formatDate(tier.toDate)})}}</small>
                            </div>
                        </td>
                    </template>

                    <template #actions="{item}">
                        <td class="py-2">
                            <button type="button" class="btn btn-lit-blue mob-w100 btn-success btn-sm" color="info"
                                    @click="navigateToAddNewPricing(item)">{{$t('assignPricing.edit')}}
                            </button>
                                    <CButton
                                         color="info"
                                          @click="navigateToAddNewPricing(item)"
                                        >{{$t('assignPricing.edit')}}</CButton>
                        </td>
                    </template>
                </CDataTable> -->
             
            </CCardBody>


            <CAlert v-if="alertValue" show color="danger">
                <div v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                    <p v-for="(value,index) in alertValue.valueList" :key="index">
                        {{value}}
                    </p>
                </div>
                <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                    <span>{{$t("cAlert.errorCode")+' : '}}</span><span v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                </div>
                <div v-if="alertValue&&alertValue.constructor==String">
                    <p>
                        {{alertValue}}
                    </p>
                </div>
            </CAlert>
            <!-- {{priceLSLength}} - {{mblassignedTierList.length}} -->
           
        </CCard>
    </div>
      
<!-- </ion-content> -->
</template>

<script>

    import router, {navigate, goBack} from "./../../router/index";
    import {mapGetters, mapActions} from "vuex";
    import {COMPONENT_NAME, PATHNAME, ORDER,DATE_TIME_FORMAT} from "./../../util/constants";
    import apiGetAssignedTiers from "./../../services/apiGetAssignedTiers";
    import SERVICE_URL, {
        FILE_NAME,
        LOG_TYPE,
        HTTP_CODES
    } from "./../../config/API_DATA";
    import {VALIDATE_SUCCESS_RES, getErrorMessage} from "../../util/apiValidate";
    import BaseConfiguration from "../../config/base.js";
    import Logger from "./../../services/logger";
    import {
        handleJWT, getErrorAlertValue, addClassToBody, removeClassBody, cloneData, cloneDeep,
        OrderByList
    } from "../../util/util";
    import Multiselect from "vue-multiselect";
    import {is} from "vee-validate/dist/rules";
    import cAgent from './../../components/form/cAgent';
    import cPaginationLenOption from "../../components/dataTable/cPaginationLenOption";

    export default {
        name: COMPONENT_NAME.ASSIGN_PRICING,

        components: {
            Multiselect,
            cAgent,
            cPaginationLenOption
        },

        data() {
            return {
                priceLSLength: 0,
                mblassignedTierList:[],
                assignPricingWatchList: {
                    filteredlistCount: null,
                    itemsPerPage: 25,
                    currentPageNum: 1,
                    lsItemsPerPage: [5, 10, 15, 25]
                },
                selectedTier: {
                    b2bId: "all",
                    agentName: "All"
                },
                assignedTierRes: {},
                assignedTiers: [],
                alertValue: null,
                tierField: [],

                assignedTierList: [],
                isResponseFetched:false
            };
        },
        watch: {
            assignedTierList: {
                immediate: false,
                deep: true,
                handler: function (newVal, oldVal) {


                    this.assignPricingWatchList.filteredlistCount = this.assignedTierList.length;


                },
            }

        },

        methods: {
            ...mapActions("sAssignPricing", ["SET_SELECTED_TIER"]),
            ...mapActions("sAssignPricing", ["SET_SELECTED_PRICING"]),
            // ...mapActions("sAssignPricing", ["SET_ISEDIT"]),

             loadData(event) {
            setTimeout(function () {
                if (this.priceLSLength < this.mblassignedTierList.length) {
                    event.target.complete();
                    appendItems(10);
        
                } else {
        
                event.target.disabled = true;
                    }
                
            }, 500);
        },
        appendItems(number) {
            var length = this.priceLSLength;
            for (var i = 1; i <= number; i++) {
                this.assignedTierList.push(this.mblassignedTierList[i+length]);
                this.priceLSLength++;
      }
    },
            getTotalPages() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getTotalPages");
                    if (this.assignPricingWatchList.filteredlistCount != null) {
                        let totalPages = this.assignPricingWatchList.filteredlistCount / this.assignPricingWatchList.itemsPerPage;
                        retValue = Math.ceil(totalPages);


                        if (retValue <= 0) {
                            retValue = 1;
                        }
                    } else {
                        retValue = 1;
                    }


                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.ASSIGN_PRICING,
                        "error in getTotalPages",
                        err.toString(),
                        "getTotalPages",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            getStartValueCount() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getStartValueCount");
                    if (this.assignPricingWatchList.filteredlistCount == 0) {
                        retValue = 0;
                    } else {
                        if (
                            this.assignPricingWatchList.itemsPerPage <
                            this.assignPricingWatchList.filteredlistCount
                        ) {
                            retValue =
                                (this.assignPricingWatchList.currentPageNum - 1) *
                                this.assignPricingWatchList.itemsPerPage;
                            retValue = retValue + 1;
                        } else {
                            retValue = 1;
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.ASSIGN_PRICING,
                        "error in getStartValueCount",
                        err.toString(),
                        "getStartValueCount",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            getAgentCountForAssTiersView(pIndex) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getAgentCountForAssTiersView");
                    let count = 0;


                    count = pIndex + 1;


                    if (count >= this.getStartValueCount() && count <= this.getFilteredListPerPage()) {
                        return true;
                    } else {
                        return false;
                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.ASSIGN_PRICING,
                        "error in getAgentCountForAssTiersView",
                        err.toString(),
                        "getAgentCountForAssTiersView",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
            getFilteredListPerPage() {
                let retValue;

                try {
                    if (BaseConfiguration.isDebug) console.log("getFilteredListPerPage");
                    if (
                        this.assignPricingWatchList.itemsPerPage <
                        this.assignPricingWatchList.filteredlistCount
                    ) {
                        if (
                            this.assignPricingWatchList.currentPageNum *
                            this.assignPricingWatchList.itemsPerPage >
                            this.assignPricingWatchList.filteredlistCount
                        ) {
                            retValue = this.assignPricingWatchList.filteredlistCount;
                        } else {
                            retValue =
                                this.assignPricingWatchList.currentPageNum *
                                this.assignPricingWatchList.itemsPerPage;
                        }
                    } else {
                        retValue = this.assignPricingWatchList.filteredlistCount;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.ASSIGN_PRICING,
                        "error in getFilteredListPerPage",
                        err.toString(),
                        "getFilteredListPerPage",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            //for custom search
            agencyNameWithCode(option) {
                return `${option.agentName} — [${option.agencyCode}]`;
            },
            formatDate(pDate) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("formatDate");
                    if (pDate != null) {
                        retValue = this.$options.filters.formatDate(
                            new Date(pDate),DATE_TIME_FORMAT.DEFAULT_DATE_FORMAT
                           
                        );
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.ASSIGN_PRICING,
                        "error in formatDataAndTime",
                        err.toString(),
                        "formatDataAndTime",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            showAlert(val) {
                this.alertValue = val;
            },

            async onChange(newVal) {
                this.selectedTier = newVal;


                this.assignedTierList = await this.getAssignedTierList(
                    this.assignedTierRes
                );


                 this.assignedTierList = OrderByList(this.assignedTierList, this.getPropToSortAssTiers, ORDER.ASC);
                //this.assignedTiers=[newVal];
            },

            navigateToAddNewPricing(selectedPricingObj) {
                try {
                    if (BaseConfiguration.isDebug) console.log("navigateToAddNewPricing");
                    //let retValue;
                    if (selectedPricingObj) {
                        this.SET_SELECTED_PRICING(selectedPricingObj);
                    } else {
                        this.SET_SELECTED_PRICING(null);
                    }
                    // this.SET_ISEDIT(isEdit);
                    navigate(
                        PATHNAME.ADD_NEW_PRICING
                    );
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.ASSIGN_PRICING,
                        "error in navigateToAddNewPricing",
                        err.toString(),
                        "navigateToAddNewPricing",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            async getAssignedTiers() {
                let returnValue;

                try {
                    let assignedTierRequest = apiGetAssignedTiers.buildRequest();
                    if (assignedTierRequest) {
                        addClassToBody(COMPONENT_NAME.ASSIGN_PRICING + ' Loading')
                        let assignedTierResponse = await apiGetAssignedTiers.getResponse(
                            assignedTierRequest
                        );

                        if (VALIDATE_SUCCESS_RES(assignedTierResponse)) {

                            returnValue = assignedTierResponse.data.data;
                            if(returnValue){
                                this.isResponseFetched=true;
                            }
                               addClassToBody(COMPONENT_NAME.ASSIGN_PRICING)

                            this.SET_SELECTED_TIER(returnValue);
                            // this.showAlert(null);
                        } else {
                                     addClassToBody(COMPONENT_NAME.ASSIGN_PRICING)

                            let error = getErrorMessage(assignedTierResponse);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.showAlert(getErrorAlertValue(error));
                            }
                        }
                    } else {
                        throw "invalid request";
                    }

                    return returnValue;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.ASSIGN_PRICING,
                        "error in getAssignedTiers",
                        err.toString(),
                        "getAssignedTiers",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getTierList(tierRes) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getTierList");
                    //let retValue;
                    let tireList = [];
                    if (tierRes) {
                        //tireList=[  ]
                        for (let tRes of Object.entries(tierRes)) {
                            let tierObj = {
                                b2bId: tRes[0],
                                agentName: tRes[1].agent,
                                agencyCode: tRes[1].agencyCode
                            };
                            tireList.push(tierObj);
                        }
                    //    console.error(this.assignedTiers)
                        tireList = OrderByList(tireList, this.getPropToSortAssTiers, ORDER.ASC);
                        if (tireList && tireList.length) {
                            tireList.unshift({b2bId: "all", agentName: "All"})
                        }
                    }
                    return tireList;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.ASSIGN_PRICING,
                        "error in getTierList",
                        err.toString(),
                        "getTierList",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            getAssignedTierList(tierRes) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getAssignedTierList");
                    //let retValue;
                    let tireList = [];

                    if (tierRes) {

                        if (this.selectedTier && this.selectedTier.b2bId == "all") {
                            for (let tRes of Object.entries(tierRes)) {
                                let tierObj = {
                                    b2bId: tRes[0],
                                    agentName: tRes[1].agent,
                                    agencyCode: tRes[1].agencyCode,
                                    pricing: tRes[1].tiers
                                };
                                tireList.push(tierObj);
                            }
                        } else {
                            for (let tRes of Object.entries(tierRes)) {
                                if (this.selectedTier && tRes[0] == this.selectedTier.b2bId) {
                                    let tierObj = {
                                        b2bId: tRes[0],
                                        agentName: tRes[1].agent,
                                        agencyCode: tRes[1].agencyCode,
                                        pricing: tRes[1].tiers
                                    };
                                    tireList.push(tierObj);
                                }
                            }
                        }
                    }
                    return tireList;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.ASSIGN_PRICING,
                        "error in getAssignedTierList",
                        err.toString(),
                        "getAssignedTierList",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            getTierField() {
                return [
                    {
                        key: "agentName",
                        label: this.$t("assignPricing.agentName")
                    },

                    {
                        key: "pricing",
                        label: this.$t("assignPricing.pricing")
                    },

                    {
                        key: "actions",
                        label: this.$t("assignPricing.actions")
                    }
                ];
            },
            getPropToSortAssTiers(pAssTierObj) {
                if (pAssTierObj.agentName) {
                    return pAssTierObj.agentName.toLowerCase();

                }
            },
           
        },

        async created() {
            if (BaseConfiguration.isDebug) console.log("created");
            let assignedTierResponse = await this.getAssignedTiers();
            this.assignedTierRes = cloneDeep(assignedTierResponse);
            this.assignedTiers = await this.getTierList(assignedTierResponse);

            this.assignedTierList = await this.getAssignedTierList(
                assignedTierResponse
            );
            this.assignedTierList = OrderByList(this.assignedTierList, this.getPropToSortAssTiers, ORDER.ASC);
            
            if(BaseConfiguration.isMobile){
                this.mblassignedTierList = this.assignedTierList;
                this.assignedTierList=[]
                for (let i = 0; i < 10; i++) {
                   this.assignedTierList.push(this.mblassignedTierList[i]) 
                   this.priceLSLength++;
                }
                // this.assignedTierList = this.mblassignedTierList
            }
            
            this.tierField = this.getTierField();
        },
        beforeCreate() {
            addClassToBody(COMPONENT_NAME.ASSIGN_PRICING);
        },

        beforeDestroy() {
            removeClassBody();
        },
    };
</script>
<style>
    @media (max-width: 400px) {
        .container-fluid {
            padding: 0px;
        }
    }
</style>